import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { useField } from 'react-final-form';
import { jsx as _jsx } from "react/jsx-runtime";
export default function FieldError(_ref) {
  let {
    name,
    className,
    showErrorOnTouch = false
  } = _ref;
  const {
    meta: {
      error,
      submitError,
      submitFailed,
      data,
      touched,
      pristine,
      dirtySinceLastSubmit
    }
  } = useField(name, {
    subscription: {
      error: true,
      submitFailed: true,
      data: true,
      submitError: true,
      touched: showErrorOnTouch,
      pristine: showErrorOnTouch,
      dirtySinceLastSubmit: true
    }
  });
  if (data !== null && data !== void 0 && data.error) {
    return /*#__PURE__*/_jsx(FieldErrorMessage, {
      className: className,
      children: data === null || data === void 0 ? void 0 : data.error
    });
  }
  return (error || submitError && !dirtySinceLastSubmit) && (submitFailed || touched && !pristine) ? /*#__PURE__*/_jsx(FieldErrorMessage, {
    className: className,
    children: error || submitError
  }) : null;
}
FieldError.propTypes = {
  name: PropTypes.string.isRequired
};
export function FieldErrorMessage(_ref2) {
  let {
    className,
    children
  } = _ref2;
  return /*#__PURE__*/_jsx("span", {
    className: cx('invalid-feedback', className),
    children: children
  });
}
export function useFieldError(name) {
  const {
    meta: {
      error,
      submitFailed,
      submitError
    }
  } = useField(name, {
    subscription: {
      error: true,
      submitFailed: true,
      submitError: true
    }
  });
  return Boolean((error || submitError) && submitFailed);
}